import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { Anchor, Text, TextButton } from '@zillow/constellation';
import { Col, Row } from '@zillow/zrs-comet';

import AnalyticsConstants from 'app/shared/constants/AnalyticsConstants';
import analyticsUtils from 'app/client/utils/analyticsUtils';
import Constants from 'app/shared/constants';

import {
    StyledItemDiv,
    StyledListingStatusDiv,
    StyledSpacer,
    StyledStatusDiv,
    StyledText,
} from './StyledComponents';

const { GA_EVENTS: { STATUS_LINK_CLICK } } = AnalyticsConstants;
const { track } = analyticsUtils;
const statusList = [
    Constants.UNFORMATTED_BRAND_NAMES.zillow,
    Constants.UNFORMATTED_BRAND_NAMES.trulia,
    Constants.UNFORMATTED_BRAND_NAMES.hotpads,
];

const propTypes = {
    syndication: PropTypes.object.isRequired,
};

const defaultProps = {};

const ListingStatus = ({ syndication }) => {
    const dispatch = useDispatch();
    const { universal } = syndication;

    const renderDisplayStatusText = displayStatus => (
        <StyledText fontColor="gray400" itemStatus={displayStatus.toLowerCase()} fontType="body">
            {displayStatus}
        </StyledText>
    );

    const handleLinkClick = brand => dispatch(track.GAEventV2(STATUS_LINK_CLICK, { action: `View${brand}URL` }));

    return (
        <StyledListingStatusDiv className="ListingStatus">
            <Row paddingY="xs">
                <Col>
                    <div>
                        <Text
                            marginBottom="xs"
                            mediaQuery={{ lg: { marginBottom: 'sm' } }}
                            fontType="h4"
                            as="div"
                        >
                            Listing Status
                        </Text>
                        <StyledStatusDiv>
                            {statusList.map((brand) => {
                                const { displayStatus, url } = syndication[brand];
                                return (
                                    <StyledSpacer paddingY="md" key={brand}>
                                        <StyledItemDiv>
                                            <Text fontColor="gray500" fontType="bodySmall">
                                                {Constants.FORMATTED_BRAND_NAMES[brand]}
                                            </Text>
                                            {displayStatus.toLowerCase() === 'posted' ? (
                                                <div onClick={() => handleLinkClick(brand)}>
                                                    <Anchor href={url} target="_blank">
                                                        {renderDisplayStatusText(displayStatus)}
                                                    </Anchor>
                                                </div>
                                            ) : renderDisplayStatusText(displayStatus)}
                                        </StyledItemDiv>
                                    </StyledSpacer>
                                );
                            })}
                        </StyledStatusDiv>
                    </div>
                </Col>
            </Row>
            {universal && (
                <Row paddingY="xs">
                    <Col>
                        <Text fontType="body" data-test="universal-messages">
                            {universal.partialMessages.map(({ url, text }, i) => (
                                url ? (
                                    <TextButton key={i} href={url} target="_blank">{`${text} `}</TextButton>
                                ) : `${text} `
                            ))}
                        </Text>
                    </Col>
                </Row>
            )}
        </StyledListingStatusDiv>
    );
};

ListingStatus.propTypes = propTypes;
ListingStatus.defaultProps = defaultProps;

export { ListingStatus };
export default ListingStatus;
